import { createTheme } from "@mui/material/styles";

const materialTheme = createTheme({
  direction: "rtl",
  typography: {
    fontFamily: "'Assistant', sans-serif",
  },
  palette: {
    secondary: {
      main: "#ffc107",
    },
  },
  components: {
    // v5 defaults TextField/Select to variant="outlined"; this app's older
    // design defaulted to "standard". Set once here (MUI_MIGRATION_PLAN.md
    // 5.9) rather than on every component, to preserve the existing look.
    MuiTextField: { defaultProps: { variant: "standard" } },
    MuiFormControl: { defaultProps: { variant: "standard" } },
    MuiSelect: { defaultProps: { variant: "standard" } },
    MuiInputLabel: { defaultProps: { variant: "standard" } },
  },
});

export { materialTheme };
